
import { Routes, Route } from "react-router-dom";

import Main from "./components/layout/Main.jsx";
import AddLesson from './pages/addLesson.jsx'
import Lessons from './pages/lessons.jsx'
import Sections from "./pages/sections.jsx";
import AddSection from "./pages/addSecion.jsx";

import SignUp from "./pages/signup.jsx";
import Signin from './pages/signIn.jsx'
import Users from "./pages/users.jsx";
import Verification from "./pages/verification.jsx";

import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import { ProtectedRoute, AdminProtection } from "./hook/useAuth.jsx";

function App() {
  return (
    <div className="App">
        <Routes>
          <Route path="/signin" element={<Signin />} />
          <Route path="/verification/:id" element={<Verification />} />
          <Route path="" element={<ProtectedRoute > <Main /></ProtectedRoute>}>
            {/* lessons */}
              <Route index element={<Lessons />} />
              <Route path="addLesson" element={<AddLesson />} />
              <Route path="editLesson/:id" element={<AddLesson />} />

            {/* Sections */}
            <Route path="section" element={<Sections />} /> 
            <Route path="viewSection/:id" element={<Sections />} /> 
            <Route path="addSection" element={<AddSection />} />
            <Route path="addIntoLesson/:lesson_id" element={<AddSection />} />
            <Route path="editSection/:id" element={<AddSection />} />

            <Route path="signup" element={<AdminProtection> <SignUp /></AdminProtection>}/>
            <Route path="users" element={<AdminProtection> <Users /></AdminProtection>}/>
          </Route>
        </Routes>
    </div>
  );
}

export default App;
